type Address = {
  ADDRESSCITY?: string;
  ADDRESSSTATEABBRV?: string;
  ADDRESSCOUNTRY?: string;
  PRIMARY?: boolean;
};

type Employment = {
  EMPLOYER?: string;
  PRIMARY?: boolean;
  END_DATE?: string;
};

export const selectCurrentUserAddress = (state: any) => {
  const aAddresses = state.Profile?.ADDRESS || [];
  const oPrimaryAddress = aAddresses.find(
    (oAddress: Address) => oAddress.PRIMARY
  );
  const oAddress = oPrimaryAddress || aAddresses[0] || {};
  return {
    city: oAddress.ADDRESSCITY || '',
    state: oAddress.ADDRESSSTATEABBRV || '',
    country: oAddress.ADDRESSCOUNTRY || '',
  };
};

export const selectCurrentUserPrimaryEmployer = (state: any): string => {
  const aEmployment = state.Profile?.EMPLOYMENT || [];
  const oPrimaryEmployment = aEmployment.find(
    (oEmployment: Employment) => oEmployment.PRIMARY && !oEmployment.END_DATE
  );
  return oPrimaryEmployment?.EMPLOYER || '';
};

export default {};
